if (!customElements.get('vbb-cart-sharpener-downsell')) {
  customElements.define('vbb-cart-sharpener-downsell', class CartSharpenerDownsell extends HTMLElement {
    constructor() {
      super();
    }

    updateCart() {
      this.cart.setLoading();

      const downsellFormConfig = fetchConfig('javascript');
      downsellFormConfig.headers['x-requested-with'] = 'XMLHttpRequest';
      delete downsellFormConfig.headers['Content-Type'];
      const newCart = this.generateNewCart();

      fetch(routes.cart_clear_url, downsellFormConfig)
        .then(response => response.json())
        .then(() => {
          // Convert entire cart to non-sharpener variants
          // Find the first pencil line items
          const firstPencilLineItem = newCart.find(({ id, properties }) => {
            return Object.values(this.variantMapping).includes(id.toString())
              && !properties.some(([key]) => key === '_bundleId')
              && !properties.some(([key]) => key === '_gwp-item');
          });

          // // Add the first pencil line item to the cart with a sharpener
          if(firstPencilLineItem) {
            newCart.unshift({
              id: Object.entries(this.variantMapping).find(([_, withoutSharpenerId]) => withoutSharpenerId === firstPencilLineItem.id)[0],
              quantity: 1,
              properties: firstPencilLineItem?.properties ?? []
            });
            // Reduce the quantity of the first pencil line item
            firstPencilLineItem.quantity = firstPencilLineItem.quantity - 1;
          }


          // Create form data for recreating the cart
          const downsellForm = new FormData();

          newCart.forEach((item, index) => {
            downsellForm.append(`items[${index}][id]`, item.id);
            downsellForm.append(`items[${index}][quantity]`, item.quantity);
            if(item.properties.length >0) {
              item.properties.forEach(([key, value]) => downsellForm.append(`items[${index}][properties][${key}]`, value));
            }
          });

          downsellForm.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          downsellForm.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);

          downsellFormConfig.body = downsellForm;

          // Recreate the cart!
          fetch(routes.cart_add_url, downsellFormConfig)
            .then(response => response.json())
            .then(response => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'vbb-product-form'
              });

              this.cart.renderContents(response);
            })
            .catch(e => console.error(e))
            .finally(() => {
              if (this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }

              this.cart.setNotLoading();
            });
        })
        .catch(e => {
          console.error(e);
          this.cart.setNotLoading();
        });
    }

    generateNewCart() {
      return Array.from(this.cartItems.querySelectorAll('.cart-item')).reduce((acc, lineItem) => {

        // Collect all '.cart-item__details--set-item li' elements
        const setItems = Array.from(lineItem.querySelectorAll('.cart-item__details--set-item li'));
        // Bundle Items
        if (setItems.length > 0) {
          // Loop through setItems and add an object for each to the accumulator
          setItems.forEach((setItem) => {
            acc.push({
              id: Object.keys(this.variantMapping).includes(setItem.dataset.variantId.toString())
                ? this.variantMapping[setItem.dataset.variantId]
                : setItem.dataset.variantId,
              quantity: parseInt(setItem.dataset.quantity, 10),
              properties: JSON.parse(decodeURIComponent(setItem.dataset.properties)),
            });
          });
        }
        // GWP
        else if(lineItem.querySelector('.gwp-label')){
          acc.push({
            id: lineItem.dataset.variantId,
            quantity: parseInt(lineItem.dataset.quantity, 10),
            properties: JSON.parse(decodeURIComponent(lineItem.dataset.properties)),
          });
        }
        else {
          // If setItems is empty, process the current lineItem as usual
          acc.push({
            id: Object.keys(this.variantMapping).includes(lineItem.dataset.variantId.toString())
              ? this.variantMapping[lineItem.dataset.variantId]
              : lineItem.dataset.variantId,
            quantity: parseInt(lineItem.dataset.quantity, 10),
            properties: JSON.parse(decodeURIComponent(lineItem.dataset.properties)),
          });
        }

        return acc;
      }, []);
    }
    connectedCallback() {
      // This is all of the pencil products that have a sharpener variant
      this.variantMapping = this.dataset.variantMapping
        .slice(0, -1)
        .split(',')
        .reduce((acc, curr) => {
          const [withSharpenerId, withoutSharpenerId] = curr.split(':');
          acc[withSharpenerId] = withoutSharpenerId;
          return acc;
        }, {});

      this.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        this.updateCart();
      });

      this.cart = document.querySelector('cart-drawer');
      this.cartItems = document.querySelector('cart-drawer-items .cart-items');
    }
  });
}


// Use same logic, if item has sub items ignore it and re-add those
